import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  CardMedia,
  Box, 
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Footer from '../navbar/Footer';
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import moment from 'moment';


const bulletinsConjonctureData = [
     {
    "title": "Bulletin de conjoncture du Burundi, troisième trimestre 2025",
    "link": "/documents/Bulletins/BTC_T3_2025.pdf",
    "image": "assets/Bulletins/bull_conj_2024_3tri.PNG",
    "date": new Date("2026-02-6"),
    "description": ""
  },
     {
    "title": "Bulletin de conjoncture du Burundi, deuxième trimestre 2025",
    "link": "/documents/Bulletins/BTC_T2_2025.pdf",
    "image": "assets/Bulletins/bull_conj_2024_3tri.PNG",
    "date": new Date("2025-08-15"),
    "description": ""
  },
   {
    "title": "Bulletin de conjoncture du Burundi, premier trimestre 2025",
    "link": "/documents/Bulletins/BTCT1- 2025.pdf",
    "image": "assets/Bulletins/bull_conj_2024_3tri.PNG",
    "date": new Date("2025-05-15"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, troisième trimestre 2024",
    "link": "/documents/Bulletins/Bulletin-trimestriel-de-Conjoncture-du-T3-2024.pdf",
    "image": "assets/Bulletins/bull_conj_2024_3tri.PNG",
    "date": new Date("2024-11-01"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, deuxième trimestre 2024",
    "link": "/documents/Bulletins/Bulletin-Trimestrielle-de-Conjoncture-du-T2-2024.pdf",
    "image": "assets/Bulletins/bull_conj_2024_2tri.PNG",
    "date": new Date("2024-09-01"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, premier trimestre 2024",
    "link": "/documents/Bulletins/Bulletin-trimestriel-de-Conjoncture-du-T1-2024.pdf",
    "image": "assets/Bulletins/bull_conj_2024_1tri.PNG",
    "date": new Date("2024-05-01"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, quatrième trimestre 2023",
    "link": "/documents/Bulletins/Bulletin-trimestrielle-de-conjoncture-T4-2023.pdf",
    "image": "assets/Bulletins/bull_conj_2023_4tri.PNG",
    "date": new Date("2023-12-30"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, troisième trimestre 2023",
    "link": "/documents/Bulletins/Bulletin-trimestrielle-de-conjoncture-T3-2023.pdf",
    "image": "assets/Bulletins/bull_conj_2023_3tri.PNG",
    "date": new Date("2023-11-01"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, deuxième trimestre 2023",
    "link": "/documents/Bulletins/BTC_T2-23b.pdf",
    "image": "assets/Bulletins/bull_conj_2023_2tri.PNG",
    "date": new Date("2023-08-01"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, quatrième trimestre 2022",
    "link": "/documents/Bulletins/Bulletin-de-conjoncture-du-4eme-trim-2022.pdf",
    "image": "assets/Bulletins/bull_conj_2022_4tri.PNG",
    "date": new Date("2022-12-30"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, troisième trimestre 2022",
    "link": "/documents/Bulletins/Bulletin-de-conjoncture-du-3eme-trim-2022.pdf",
    "image": "assets/Bulletins/bull_conj_2022_3tri.PNG",
    "date": new Date("2022-11-01"),
    "description": " "
  },
  {
    "title": "Bulletin de conjoncture du Burundi, deuxième trimestre 2022",
    "link": "/documents/Bulletins/Bulletin-de-conjoncture-du-2eme-trim-2022-_1_-_1_.pdf",
    "image": "assets/Bulletins/bull_conj_2022_2tri.PNG",
    "date": new Date("2022-08-15"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, premier trimestre 2022",
    "link": "/documents/Bulletins/Bulletin-de-conjoncture-T1_2022.pdf",
    "image": "assets/Bulletins/bull_conj_2022_1tri.PNG",
    "date": new Date("2022-05-24"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, deuxième trimestre 2021",
    "link": "/documents/Bulletins/Bulletin-de-conjoncture-du-2eme-trim-2021-1.pdf",
    "image": "assets/Bulletins/bull_conj_2021_2tri.PNG",
    "date": new Date("2021-08-16"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, premier trimestre 2021",
    "link": "/documents/Bulletins/Bulletin-de-conjoncture-du-1er-trim-2021-1.pdf",
    "image": "assets/Bulletins/bull_conj_2021_1tri.PNG",
    "date": new Date("2021-05-14"),
    "description": ""
  },
  {
    "title": "Bulletin de conjoncture du Burundi, troisième trimestre 2020",
    "link": "/documents/Bulletins/Bulletin-de-conjoncture-du-3eme-trim-2020.pdf",
    "image": "assets/Bulletins/bull_conj_2020_3tri.PNG",
    "date": new Date("2020-11-24"),
    "description": " "
  }
];



function BulletinConjoncture() {
  const navigate = useNavigate(); 
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsConjonctureData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);

    if (year === 'Tous') {
      setFilteredBulletins(bulletinsConjonctureData);
      setVisibleCount(2); 
    } else {
      const filtered = bulletinsConjonctureData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear();
        return bulletinYear === parseInt(year);
      });
      setFilteredBulletins(filtered);
      setVisibleCount(2); 
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C', 
      },
      secondary: {
        main: '#f50057', 
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px', 
            textTransform: 'none', 
            fontWeight: 'bold', 
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            transition: 'transform 0.2s ease-in-out', 
            '&:hover': {
              transform: 'scale(1.03)', 
              boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)', 
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
            Les Bulletins de Conjoncture
          </Typography>
          <Divider style={{ margin: '20px 0' }} />
           
          <Typography variant="body1" align="justify" gutterBottom>
               Cette section présente les Bulletins de Conjoncture de l'INSBU, qui fournissent une analyse régulière de l'économie burundaise, des données sur les importations et exportations, et des indicateurs sociaux clés.
           </Typography>

          <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de publication"
              variant="outlined"
            >
              <MenuItem value="Tous">Tous les bulletins</MenuItem>
              {[...new Set(bulletinsConjonctureData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort((a, b) => b - a)  
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

       
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'row', height: '100%' }}>
                  <CardMedia
                    component="img"
                    sx={{ width: 31, height: 60, m: 2, cursor: 'pointer' }}
                    image={bulletin.image}
                    alt={bulletin.title}
                    onClick={() => window.open(bulletin.link, '_blank')} 
                  />
                  <CardContent style={{ flex: 1, padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main, cursor: 'pointer' }} onClick={() => window.open(bulletin.link, '_blank')}>
                      {<DownloadIcon />} {bulletin.title}
                      </Typography>
                      <Typography variant="body2" component="div" style={{ marginBottom: '20px', color: '#555' }}>
                        {bulletin.description}
                      </Typography>
                          <Typography variant="caption" color="textSecondary">
                                  Publié en {moment(bulletin.date).format('MMMM YYYY')}
                         </Typography>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

     
          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Bulletins
            </Button>
          )}

          <br />
          <br />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
            <strong>Note :</strong> Les Bulletins de Conjoncture du commerce extérieur sont publiés trimestriellement, généralement <strong>45 jours</strong> après la fin de chaque trimestre, selon le calendrier suivant :
            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>15 février</strong> - Publication des données du quatrième trimestre</li>
              <li><strong>15 mai</strong> - Publication des données du premier trimestre</li>
              <li><strong>15 août</strong> - Publication des données du deuxième trimestre</li>
              <li><strong>15 novembre</strong> - Publication des données du troisième trimestre</li>
            </ul>
          </Typography>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button 
              onClick={() => navigate('/bulletin')} 
              style={{
                marginTop: '5px',
                backgroundColor: '#388E3C', 
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page des bulletins
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default BulletinConjoncture;